function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.3 0.313818C-0.1 0.713818 -0.1 1.31382 0.3 1.71382L3.5 4.91382L0.3 8.21382C-0.1 8.61382 -0.1 9.21382 0.3 9.61382C0.5 9.81382 0.7 9.91382 1 9.91382C1.2 9.91382 1.5 9.81382 1.7 9.61382L5.6 5.61382C6 5.21382 6 4.61382 5.6 4.21382L1.7 0.213819C1.3 -0.0861816 0.7 -0.0861816 0.3 0.313818Z",
  fill: "#9F9F9F"
});

function SvgArrowForward({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDYgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4zIDAuMzEzODE4Qy0wLjEgMC43MTM4MTggLTAuMSAxLjMxMzgyIDAuMyAxLjcxMzgyTDMuNSA0LjkxMzgyTDAuMyA4LjIxMzgyQy0wLjEgOC42MTM4MiAtMC4xIDkuMjEzODIgMC4zIDkuNjEzODJDMC41IDkuODEzODIgMC43IDkuOTEzODIgMSA5LjkxMzgyQzEuMiA5LjkxMzgyIDEuNSA5LjgxMzgyIDEuNyA5LjYxMzgyTDUuNiA1LjYxMzgyQzYgNS4yMTM4MiA2IDQuNjEzODIgNS42IDQuMjEzODJMMS43IDAuMjEzODE5QzEuMyAtMC4wODYxODE2IDAuNyAtMC4wODYxODE2IDAuMyAwLjMxMzgxOFoiIGZpbGw9IiM5RjlGOUYiLz4KPC9zdmc+Cg==";
export { SvgArrowForward as ReactComponent };